export const measures = {
  m2: {
    locale: 'm',
    areaLocale: 'm²',
    key: 'm2',
    ratio: 0.092903,
  },
  f2: {
    locale: 'ft',
    areaLocale: 'ft²',
    key: 'f2',
    ratio: 10.764,
  },
};

export const linearMeasures = {
  mi: {
    locale: 'mi',
    key: 'mi',
    ratioToKilometer: 1.60934,
  },
  km: {
    locale: 'km',
    key: 'km',
    ratioToMile: 0.621371,
  },
};
